import * as React from 'react';
import { RouteComponentProps, useLocation } from 'react-router';
import { Tabs } from '@teamsnap/teamsnap-ui';

import './dashboard.scss';
import OrganizationEditForm from '../../components/form/organization-edit-form';
import OrgStructure from '../../components/organization/organization-structure';
import * as ShowOrganization from '../../core/gql/queries/show-organizations';
import { useQuery } from '@apollo/client';
import OrgAccountsManagement from 'components/organization/organization-accounts-management';

export interface Props extends RouteComponentProps<any> {}

const OrganizationSettings: React.FunctionComponent<Props> = ({
  match: {
    params: { orgId },
  },
}) => {
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);
  const location = useLocation();
  const showOrgQuery = ShowOrganization.QUERY;

  const getOrganization = useQuery(showOrgQuery, {
    variables: { organizationId: +orgId },
    skip: !orgId,
  });

  const organization = getOrganization.data?.showOrganization;

  const tabs = React.useCallback(
    (orgIdAsInt) => {
      const tabsObjects = [
        {
          testId: 'General',
          heading: (
            <span role="tab" tabIndex={0} id="general-tab">
              General
            </span>
          ),
          content: (
            <div className="u-xs-padMd u-sm-spaceTopLg u-flexExpandSides">
              {!orgIdAsInt ? null : <OrganizationEditForm employeeView={false} selectedOrganizationId={orgIdAsInt} />}
            </div>
          ),
        },
        {
          testId: 'Program Attributes',
          heading: (
            <span role="tab" tabIndex={0} id="program-attributes-tab">
              Program Attributes
            </span>
          ),
          content: (
            <div className="u-xs-padMd u-sm-spaceTopLg u-flexExpandSides">
              <OrgStructure orgId={orgIdAsInt} />
            </div>
          ),
        },
      ];

      if (organization?.country === 'United States' || organization?.country === 'Canada')
        {
        tabsObjects.push({
          content: <OrgAccountsManagement organization={organization} />,
          testId: 'Merchant Accounts',
          heading: (
            <span role="tab" tabIndex={0} id="merchant-accounts-tab" data-testid="OrganizationSettings--merchant-accounts">
              Merchant Accounts
            </span>
          ),
        });
      }

      return tabsObjects;
    },
    [organization]
  );

  React.useEffect(() => {
    if (organization?.country === 'United States' || organization?.country === 'Canada')
    {
      if (location.pathname.includes('merchant-accounts')) {
        const merchantAccountIndex = tabs(organization.id).findIndex((tab) => tab.testId === 'Merchant Accounts');
        setActiveTabIndex(merchantAccountIndex);
      }
    }
  }, [location.pathname, orgId, organization, tabs]);

  return (
    <div id="settings" className="container">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1>Organization Settings</h1>
          </div>
        </div>

        <Tabs activeIndex={activeTabIndex} setActiveIndex={setActiveTabIndex} tabs={tabs(+orgId)} />
      </div>
    </div>
  );
};

export default OrganizationSettings;
